import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { getOnePercent } from '../../helpers';

export default class VerticalLine extends PureComponent {
  static propTypes = {
    height: PropTypes.number,
    normMin: PropTypes.number,
    normMax: PropTypes.number,
    y: PropTypes.func,
    x: PropTypes.func,
  }

  static defaultProps = {
    width: 0,
    height: 0,
    y: () => {},
    x: () => {},
  }

  render() {
    const { height, normMin, normMax, y, x } = this.props;
    const onePercent = getOnePercent(normMin, normMax);
    const getX = index => x(onePercent * index);
    const line = [0, 35, 65, 100];

    return (
      <g>
        {line.map((item, index, list) => (
          <line
            key={item}
            y1={0}
            y2={y(height)}
            stroke='#a2b3c2'
            strokeWidth={index === list.length - 1 ? 0.5 : 1}
            x1={getX(item, list)}
            x2={getX(item, list)}
          />
        ))}
      </g>
    );
  }
}
